<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="organisationTable"
            :items="tableData"
            :fields="fields">
            <template v-slot:cell(action)="data">
                <b-button
                    class="btn-sign-out btn-module-sign-out remove-icon-margin"
                    v-b-tooltip.hover
                    variant="primary-icon-only"
                    :title="$t('common.delete')"
                    @click="removeOrganisation(data.item.id)">
                </b-button>
            </template>

            <template #options>
                <b-button
                    class="btn-add btn-add-organisations"
                    v-b-modal="'add-organization-modal'"
                    variant="primary">
                    {{ $t('management.add_organization') }}
                </b-button>
            </template>
        </design-2021-apprentice-data-table>

        <design-2021-management-organizations-add-modal-component
            @addOrg="addOrganization($event)"
            ref="add-organization-modal"
            :organizations-in="this.organizations">
        </design-2021-management-organizations-add-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-management-organizations-index-component',
    props: ['organizationsIn'],
    data() {
        return {
            organizations: this.organizationsIn,
            fields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    computed: {
        tableData() {
            return this.organizations.map((org) => {
                return {
                    id: org.id,
                    name: org.name,
                };
            });
        },
    },
    methods: {
        removeOrganisation(organizationId) {
            this.axios.delete(this.routes.managementDeleteOrganization(organizationId)).then(
                (response) => {
                    this.alert.success();
                    this.organizations = this.organizations.filter((item) => item.id !== organizationId);
                    this.$refs['add-organization-modal'].removeOrgFromIncludedOrganizations(organizationId);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        addOrganization(organization) {
            this.organizations.push(organization);
        },
    },
};
</script>

<style scoped></style>
